import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import TextInput from "../reusableComponents/components/generics/TextInput";
import Checkbox from "@mui/material/Checkbox";
import { Form, Field } from "react-final-form";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { forgotPassword, login, refreshAuthToken } from "../action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const GridPadding = styled(Grid)({
  marginTop: "2rem",
  marginBottom: "2rem",
});

const ForgotPasswordForm = ({ title }) => {
  const [isSuccess, setIsSeucess] = useState();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const ForgotSuccess = useSelector((state) => state);

  useEffect(() => {
    if (
      ForgotSuccess?.profileReducer?.forgotResponseData?.newPasswordRequest
        ?.success
    ) {
      setIsSeucess(
        ForgotSuccess?.profileReducer?.forgotResponseData?.newPasswordRequest
          ?.success
      );
    }
  }, [ForgotSuccess]);
  //   if (isSuccess) {
  //     navigate("/success");
  //   }
  const onSubmit = async (values) => {
    const respone = await dispatch(forgotPassword(values));
  };
  const validate = (values) => {
    const errors = {};
    if (!values.email) {
      errors.email = "Email Address is required";
    }
    return errors;
  };

  if (isSuccess) {
    return (
      <Grid item xs={12} className="sign-in-input">
        <Typography
          variant="h6"
          sx={
            title
              ? { fontWeight: "bold", marginLeft: "5rem", color: "red" }
              : { fontWeight: "bold" }
          }
        >
          {t("newPasswordRequestSuccess")}
        </Typography>
      </Grid>
    );
  }

  return (
    <Grid item xs={12} className="sign-in-input">
      <Typography
        variant="h6"
        sx={
          title
            ? { fontWeight: "bold", marginLeft: "5rem", color: "red" }
            : { fontWeight: "bold" }
        }
      >
        {title ? t("Oops! Link has been expired") : t("Forgot Password")}
      </Typography>
      <Grid container>
        <Form
          onSubmit={onSubmit}
          // validate={validate}
          render={({
            handleSubmit,
            form,
            submitting,
            pristine,
            values,
            errors,
          }) => {
            return (
              <Grid item xs={12}>
                <form onSubmit={handleSubmit}>
                  <Grid item xs={12}>
                    <GridPadding>
                      <Field
                        name="email"
                        component={TextInput}
                        label={t(
                          "Please enter your email address to reset your password."
                        )}
                        type="email"
                        required={true}
                        error={errors.email}
                        placeholder={t("Please Enter Your Email Address")}
                      />
                    </GridPadding>
                  </Grid>
                  <Button
                    variant="contained"
                    fullWidth
                    type="submit"
                    disabled={
                      submitting || pristine || Object.keys(errors).length > 0
                    }
                  >
                    {t("Submit")}
                  </Button>
                </form>
              </Grid>
            );
          }}
        />
      </Grid>
    </Grid>
  );
};

export default ForgotPasswordForm;
